import type { HTMLAttributes } from 'react'
import { cn } from '@/lib/utils'

/**
 * Acl.tsx / Admin.tsx で反復している
 * `rounded-lg border bg-card shadow-sm` パターンを抽出したもの。
 */
export function Card({ className, children, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={cn('rounded-lg border bg-card shadow-sm', className)} {...props}>
      {children}
    </div>
  )
}

/**
 * `flex items-center justify-between border-b px-6 py-4` ヘッダー。
 * 右側に操作ボタンを置く用途（Acl.tsx の「保存」「新規追加」ボタン等）を想定し、
 * children を素通しする（`justify-between` は呼び出し側で複数要素を渡すことで成立する）。
 */
export function CardHeader({ className, children, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={cn('flex items-center justify-between border-b px-6 py-4', className)} {...props}>
      {children}
    </div>
  )
}

export function CardTitle({ className, children, ...props }: HTMLAttributes<HTMLHeadingElement>) {
  return (
    <h2 className={cn('font-semibold', className)} {...props}>
      {children}
    </h2>
  )
}

export function CardDescription({ className, children, ...props }: HTMLAttributes<HTMLParagraphElement>) {
  return (
    <p className={cn('mt-1 text-sm text-muted-foreground', className)} {...props}>
      {children}
    </p>
  )
}

export function CardContent({ className, children, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={cn('p-6', className)} {...props}>
      {children}
    </div>
  )
}

export function CardFooter({ className, children, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={cn('flex items-center gap-2 border-t px-6 py-4', className)} {...props}>
      {children}
    </div>
  )
}
